<template>
    <div>
        <transition name="dialogfade">
            <k-dialog v-if="showDialog"
                class="edit-condition-dialog blueprint-dialog"
                :title="dialogTitle"
                @close="closeDialog">
                <div class="dialog-body" v-if="!isLoading">
                    <div class="blueprint-summary__container">
                        <p class="summary-point"><span>Loan Number: </span>{{ blueprintData?.loanFile.loanNumber }}</p>
                        <p class="summary-point"><span>Borrower: </span>{{ blueprintData?.borrowers[0].borrower.first }} {{ blueprintData?.borrowers[0].borrower.last }}</p>
                        <p class="summary-point"><span>Type: </span>{{ loanTypeDisplay }}</p>
                        <p class="summary-point"><span>Blueprint File Id: </span>{{ blueprintData?.loanFile.fileId }}</p>
                    </div>
                    <k-tabstrip :selected="selectedBlueprintTab" @select="onBlueprintTabSelected" :tabs="blueprintTabs">
                        <template v-slot:borrower>
                            <div class="blueprint__borrower-tab">
                                <div class="loan-detail__section">
                                    <section class="borrower-tab__section borrower__loan-type-container">
                                        <h2 class="section--title">Loan Number</h2>
                                        <k-input class="file__loan-number-input" v-if="blueprintDataEdit?.loanFile" v-model="blueprintDataEdit.loanFile.loanNumber" @input="checkForChanges" />
                                        <h2 class="section--title">Agency</h2>
                                        <k-radio :name="'loantype'"
                                                :value="1"
                                                :checked="blueprintDataEdit?.loanFile.agency === 1"
                                                @change="onLoanTypeChange"
                                                :label="'FNMA'"></k-radio>
                                        <k-radio :name="'loantype'"
                                                :value="2"
                                                :checked="blueprintDataEdit?.loanFile.agency === 2"
                                                @change="onLoanTypeChange"
                                                :label="'FHLMC'"></k-radio>
                                        <k-radio :name="'loantype'"
                                                :value="3"
                                                :checked="blueprintDataEdit?.loanFile.agency === 3"
                                                @change="onLoanTypeChange"
                                                :label="'FHA'"></k-radio>
                                        <k-radio :name="'loantype'"
                                                :value="4"
                                                :checked="blueprintDataEdit?.loanFile.agency === 4"
                                                @change="onLoanTypeChange"
                                                :label="'VA'"></k-radio>
                                        <k-radio :name="'loantype'"
                                                :value="5"
                                                :checked="blueprintDataEdit?.loanFile.agency === 5"
                                                @change="onLoanTypeChange"
                                                :label="'USDA'"></k-radio>
                                    </section>
                                    <section class="borrower-tab__section borrower__loan-actions-container">
                                        <h2 class="section--title">Number of Years Analyzed</h2>
                                        <k-radio :name="'yearsanalyzed'"
                                                :value="1"
                                                :checked="blueprintDataEdit?.loanFile.want2yrAnalysis"
                                                @change="onYearsAnalyzedChange"
                                                :label="'Two'"></k-radio>
                                        <k-radio :name="'yearsanalyzed'"
                                                :value="0"
                                                :checked="!blueprintDataEdit?.loanFile.want2yrAnalysis"
                                                @change="onYearsAnalyzedChange"
                                                :label="'One'"></k-radio>
                                    </section>
                                    <section class="borrower-tab__section borrower__loan-taxes-container">
                                        <h2 class="section--title">Most Recent Tax Year</h2>
                                        <k-dropdown :data-items="taxYearSelects" 
                                                    v-if="blueprintDataEdit" 
                                                    v-model="blueprintDataEdit.loanFile.analysisY1"
                                                    @change="checkForChanges"></k-dropdown>
                                    </section>
                                    <section class="borrower-tab__section borrower__loan-checkbox-container">
                                        <h2 class="section--title">Other</h2>
                                        <k-checkbox v-if="blueprintDataEdit" 
                                                    v-model="blueprintDataEdit.loanFile.isLockedForUW" 
                                                    :label="'Lock for Underwriting'"
                                                    @change="checkForChanges"></k-checkbox>
                                        <k-checkbox v-if="blueprintDataEdit" 
                                                    v-model="blueprintDataEdit.loanFile.adjustSelectedIncome" 
                                                    :label="'Adjust Selected Income'"
                                                    @change="checkForChanges"></k-checkbox>
                                    </section>

                                    <div class="blueprint-file__loader-container" v-if="isLoadingFile">
                                        <loader :size="'large'" :type="'infinite-spinner'"></loader>
                                    </div>
                                </div>

                                <div class="borrower-detail__section" v-if="blueprintDataEdit?.borrowers">
                                    <div class="borrowers__title-container">
                                        <h2 class="section--title">Borrowers</h2>
                                        <k-button class="add-borrower__btn" @click="onAddBorrower"><span class="k-icon k-i-plus"></span> Add Borrower</k-button>
                                    </div>
                                    <div class="borrowers__container"  v-if="!isLoadingBorrowers" >
                                        <div class="borrower__container" v-for="borrowerData in blueprintDataEdit.borrowers" :key="borrowerData.borrower.borrowerId">
                                            <div class="borrower__container-name">
                                                <h3>{{ borrowerData.borrower.first }} {{ borrowerData.borrower.last }}<span title="Edit borrower" class="k-icon k-i-track-changes-enable" @click="onEditBorrowerInfo(borrowerData.borrower.borrowerId)"></span></h3>
                                                <div class="borrower__action-btns">
                                                    <k-button class="add-borrower-income__btn" @click="onAddBorrowerIncome(borrowerData.borrower.borrowerId)"><span class="k-icon k-i-plus"></span> Add Income</k-button>
                                                    <k-button class="delete-borrower__btn" @click="onDeleteBorrower(borrowerData.borrower.borrowerId)"><span class="k-icon k-i-delete k-i-trash"></span> Delete Borrower</k-button>
                                                </div>
                                            </div>
                                            <k-grid v-if="borrowerData.incomeSummary" class="borrower-income__grid" :data-items="borrowerData.incomeSummary"
                                                    :columns="borrowerIncomeColumns">
                                                <template v-slot:editIncome="{props}">
                                                    <div class="edit-income-col">
                                                        <k-button title="Edit income description" :disabled="props.dataItem.type === 'OTHER'" v-on:click.stop="onEditBorrowerIncome(borrowerData.borrower.borrowerId, props.dataItem)"><span class="k-icon k-i-track-changes-enable"></span></k-button>
                                                        <k-button title="Delete income" v-on:click.stop="onDeleteBorrowerIncome(borrowerData.borrower.borrowerId, props.dataItem)"><span class="k-icon k-i-delete k-i-trash"></span></k-button>
                                                    </div>
                                                </template>
                                            </k-grid>
                                        </div>
                                    </div>

                                    <div class="borrowers__container" v-if="isLoadingBorrowers">
                                        <div class="blueprint-borrowers__loader-container">
                                            <loader :size="'large'" :type="'infinite-spinner'"></loader>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:income>
                            Income
                        </template>
                    </k-tabstrip>
                </div>
                <k-dialog-actions>
                    <k-button v-bind:class="['dialog__btn dialog__btn--save', { 'dialog__btn--save-active': !saveChangesBtnDisabled }]" @click="updateFile" :disabled="saveChangesBtnDisabled">Save</k-button>
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="closeDialog">Close</k-button>
                </k-dialog-actions>

                <div class="conditions__loader-container" v-if="isLoading">
                    <loader :size="'large'" :type="'infinite-spinner'"></loader>
                </div>
            </k-dialog>
        </transition>

        <transition name="dialogfade">
            <k-dialog v-if="showBorrowerEditDialog"
                    :title="editBorrowerDialogTitle"
                    v-bind:class="['edit-condition-dialog', 'edit-borrower__dialog', { 'edit-borrower-info': editBorrowerInfoMode || addBorrowerMode }, { 'edit-borrower-income': editBorrowerIncomeMode }, { 'add-borrower-income': addBorrowerIncomeMode }]"
                    @close="toggleEditBorrowerDialog">
                <div class="edit-borrower-dialog__body">
                    <div v-if="editBorrowerInfoMode" class="edit-borrower-info__container">
                        <div class="borrower-name__inputs">
                            <k-input v-model="selectedBorrower.borrower.first" @input="checkForBorrowerInfoChanges" :label="'First Name'" />
                            <k-input v-model="selectedBorrower.borrower.last" @input="checkForBorrowerInfoChanges" :label="'Last Name'" />
                        </div>
                        <k-input class="ssn__input" v-model="selectedBorrower.borrower.ssn" @input="checkForBorrowerInfoChanges" :label="'SSN (last 4)'" />
                    </div>
                    <div v-if="addBorrowerMode" class="edit-borrower-info__container">
                        <div class="borrower-name__inputs">
                            <k-input v-model="newBorrower.first" @input="checkForNewBorrowerChanges" :label="'First Name'" />
                            <k-input v-model="newBorrower.last" @input="checkForNewBorrowerChanges" :label="'Last Name'" />
                        </div>
                        <k-input class="ssn__input" v-model="newBorrower.ssn" @input="checkForNewBorrowerChanges" :label="'SSN (last 4)'" />
                    </div>
                    <div v-if="editBorrowerIncomeMode" class="edit-borrower-info__container">
                        <k-input class="income-name__input" v-model="selectedBorrowerIncome.name" @input="checkForIncomeNameChanges" :label="'Description'" />
                    </div>
                    <div v-if="addBorrowerIncomeMode" class="edit-borrower-info__container">
                        <div class="income-type__switch-container">
                            <p :class="['grid__toggle-label', { 'grid__toggle-label--selected': showIncomeTypes }]">Income Types</p>
                            <k-switch v-model="showIncomeTypes" :on-label="''" :off-label="''"></k-switch>
                            <p :class="['grid__toggle-label', { 'grid__toggle-label--selected': !showIncomeTypes }]">Other Income Types</p>
                        </div>
                        
                        <k-dropdown v-if="showIncomeTypes"
                                    :data-items="filteredIncomeTypes" 
                                    :label="'Select income type'"
                                    :filterable="true"
                                    @filterchange="onIncomeTypeFilterChange"
                                    @change="onIncomeTypeSelected"></k-dropdown>

                        <k-dropdown v-if="!showIncomeTypes"
                                    :data-items="filteredOtherIncomeTypes" 
                                    :label="'Select income type'"
                                    :filterable="true"
                                    @filterchange="onOtherIncomeTypeFilterChange"
                                    @change="onIncomeTypeSelected"></k-dropdown>

                        <k-input class="income-name__input" v-model="newIncomeType.name" :disabled="newIncomeType.type === 'OTHER'" :label="'Description'" />
                     </div>
                </div>
                <k-dialog-actions>
                    <k-button class="dialog__btn dialog__btn--save" v-on:click="updateBorrowerInfo" :disabled="updateBorrowerInfoBtnDisabled">Save</k-button>
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="toggleEditBorrowerDialog">Cancel</k-button>
                </k-dialog-actions>
            </k-dialog>
        </transition>

        <transition name="dialogfade">
            <k-dialog v-if="showConfirmDialog"
                class="edit-condition-dialog confirm-junk-dialog"
                :title="'Please Confirm'"
                @close="toggleConfirmDialog">
                <div>
                    <p v-if="deleteBorrowerIncome" class="confirm-junk--msg">Are you sure you would like to delete income source <span>{{ selectedBorrowerIncome.name }}</span>?</p>
                    <p v-if="deleteBorrower" class="confirm-junk--msg">Are you sure you would like to delete borrower <span>{{ selectedBorrower.borrower.first }} {{ selectedBorrower.borrower.last }}</span>?</p>
                </div>

                <k-dialog-actions v-if="deleteBorrowerIncome">
                    <k-button class="dialog__btn dialog__btn--close" disabled v-on:click="confirmDeleteIncome">Confirm</k-button>
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="toggleConfirmDialog">Cancel</k-button>
                </k-dialog-actions>

                <k-dialog-actions v-if="deleteBorrower">
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="confirmDeleteBorrower">Confirm</k-button>
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="toggleConfirmDialog">Cancel</k-button>
                </k-dialog-actions>
            </k-dialog>
        </transition>

        <k-notification-group class="conditions__notification-container">
            <k-fade :appear="successNotification">
                <k-notification v-if="successNotification"
                                :type="{ style: 'success', icon: true }"
                                :closable="true"
                                @close="onCloseNotification('successNotification')">
                    <span>{{ notificationMsg }}</span>
                </k-notification>
            </k-fade>
        </k-notification-group>

        <transition name="dialogfade">
          <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
            <p class="error-dialog__msg">{{ errorMsg }}</p>
          </k-dialog>
        </transition>       
    </div>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';

    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';
    import { Input, Switch, Checkbox, RadioButton } from "@progress/kendo-vue-inputs";
    import { Button } from '@progress/kendo-vue-buttons';
    import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
    import { Notification, NotificationGroup } from "@progress/kendo-vue-notification";
    import { Fade, Reveal, Slide } from "@progress/kendo-vue-animation";
    import { TabStrip } from '@progress/kendo-vue-layout';

    import { filterBy } from '@progress/kendo-data-query';

    import isEqual from 'lodash.isequal';
    import cloneDeep from 'lodash.clonedeep';

    export default {
        props: ['loanId', 'loanNumber', 'showDialog'],
        emits: ['dialogclosed', 'requesterror'],  
        data() {
            return {
                addBorrowerIncomeMode: false,
                addBorrowerMode: false,
                agencyTypes: [
                    { display: 'FNMA', value: 1 },
                    { display: 'FHLMC', value: 2 },
                    { display: 'FHA', value: 3 },
                    { display: 'VA', value: 4 },
                    { display: 'USDA', value: 5 }
                ],
                blueprintData: null,
                blueprintDataEdit: null,
                blueprintTabs: [
                    { title: 'Borrower', content: 'borrower' },
                    { title: 'Income', content: 'income' }
                ],
                borrowerIncomeColumns: [
                    { field: 'type', title: 'Type' },
                    { field: 'name', title: 'Description' },
                    { cell: 'editIncome', width: '120px', columnMenu:false, filterable: false }
                ],
                confirmMsg: '',
                deleteBorrower: false,
                deleteBorrowerIncome: false,
                dialogTitle: 'Blueprint Connect',
                editBorrowerDialogTitle: '',
                editBorrowerInfoMode: false,
                editBorrowerIncomeMode: false,
                errorAlert: false,
                errorMsg: '',
                errorTitle: '',
                filteredIncomeTypes: [],
                filteredOtherIncomeTypes: [],
                incomeTypes: ['Employed', 'Change of Jobs', 'SE-SCH C', 'SE-SCH C EZ', 'SE-SCH F', 'SE-1065', 'SE-1120S', 'SE-1120', 'Pension / Annuities',
                    'SS Retirement / Disability', '401k / IRA', 'Child Support', 'Alimony', 'Gross Up Income', 'Military', 'Interest / Dividend', 'Assets as Income',
                    'Capital Gains', '1099 Services', 'Unemployment', 'Royalty', 'Bank Statement'],  
                isLoading: false,  
                isLoadingBorrowers: false,  
                isLoadingFile: false,
                loanTypeDisplay: '',
                newBorrower: {
                    first: '',
                    last: '',
                    ssn: ''
                },
                newIncomeType: {
                    type: '',
                    name: ''
                },
                notificationMsg: '',  
                otherIncomeTypes: ['Automobile Allowance', 'Boarder Income', 'COLA', 'Disability - Long Term', 
                    'Trust Income', 'Foreign Income', 'Foster-Care', 'Housing or Parsonage', 'Mortgage Credit Certificates', 'Mortgage Differential Payments', 'Notes Receivable Income', 
                    'Public Assistance', 'Non-Borrower Household', 'Temporary Leave Income', 'VA Benefits Payments', 'Misc Income', 'Accessory Unit Income', 'Food Stamps',
                    'TANF', 'SNAP', 'EBT', 'Section 8 Housing', 'EITC', 'WIC', 'Medicaid'],  
                saveChangesBtnDisabled: true,
                selectedBlueprintTab: 0, 
                selectedBorrower: {},
                selectedBorrowerIncome: {},
                showBorrowerEditDialog: false,
                showConfirmDialog: false,
                showErrorDialog: false,   
                showIncomeTypes: true,
                successNotification: false,
                updateBorrowerInfoBtnDisabled: true
            }
        },
        mounted() {
            this.incomeTypes.sort((a, b) => a.localeCompare(b));
            this.otherIncomeTypes.sort((a, b) => a.localeCompare(b));

            this.filteredIncomeTypes = this.incomeTypes.slice();
            this.filteredOtherIncomeTypes = this.otherIncomeTypes.slice();
        },
        computed: {
            taxYearSelects() {
                let result = [];

                result.push(new Date().getFullYear());

                let baseYear = new Date();
                for(var i = 0; i < 4; i++) {
                    result.push(new Date(baseYear.setFullYear(baseYear.getFullYear() - 1)).getFullYear());
                }

                return result;
            }
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.getBlueprintData()
                } else {
                    this.blueprintData = null;
                    this.blueprintDataEdit = null;

                    this.saveChangesBtnDisabled = true;
                    this.updateBorrowerInfoBtnDisabled = true;

                    this.selectedBorrower = {};
                    this.selectedBorrowerIncome = {};
                }
            }
        },
        methods: {
            async addBorrower() {
                let borrower = {
                    First: this.newBorrower.first,
                    Last: this.newBorrower.last,
                    SSN: this.newBorrower.ssn,
                    FileFileId: this.blueprintData.loanFile.fileId
                };

                this.toggleEditBorrowerDialog();

                this.isLoadingBorrowers = true;

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.AddBorrower(borrower, tokenResponse.accessToken)
                .then(res => {
                    this.blueprintData = res.data.data;
                    this.blueprintDataEdit = cloneDeep(this.blueprintData);
                    this.loanTypeDisplay = this.agencyTypes.find(type => type.value === this.blueprintData.loanFile.agency).display;

                    this.isLoadingBorrowers = false;
                    this.showNotification('Borrower added successfully');
                }).catch(error => {
                    this.isLoadingBorrowers = false;
                    this.errorTitle = "Failed to Add Borrower";

                    if (error.data) {
                      this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }
                    this.onRequestError(this.errorTitle, this.errorMsg);
                }); 
            },
            checkForBorrowerInfoChanges() {
                let selectedBorrower = this.blueprintDataEdit.borrowers.find(b => b.borrower.borrowerId === this.selectedBorrower.borrower.borrowerId);

                if (selectedBorrower) {
                    if (isEqual(selectedBorrower, this.selectedBorrower)) {
                        return this.updateBorrowerInfoBtnDisabled = true;
                    }

                    this.updateBorrowerInfoBtnDisabled = false;
                }
            },
            checkForChanges() {
                if (isEqual(this.blueprintData.loanFile, this.blueprintDataEdit.loanFile)) {
                    return this.saveChangesBtnDisabled = true;
                }

                this.saveChangesBtnDisabled = false;
            },
            checkForIncomeNameChanges() {
                    let borrowerIncome = this.selectedBorrower.incomeSummary.find(i => i.id === this.selectedBorrowerIncome.id);

                    if (borrowerIncome) {
                        if (isEqual(borrowerIncome.name, this.selectedBorrowerIncome.name)) {
                            return this.updateBorrowerInfoBtnDisabled = true;
                        }

                        //this.updateBorrowerInfoBtnDisabled = false;
                    }
            },
            checkForNewBorrowerChanges() {
                if (!this.newBorrower.first || !this.newBorrower.last) {
                    return this.updateBorrowerInfoBtnDisabled = true;
                }

                this.updateBorrowerInfoBtnDisabled = false;
            },
            closeDialog() {
                this.$emit('dialogclosed');
            }, 
            async confirmDeleteBorrower() {
                let borrower = {
                    FileFileId: this.blueprintData.loanFile.fileId,
                    BorrowerId: this.selectedBorrower.borrower.borrowerId
                };

                this.toggleConfirmDialog();

                this.isLoadingBorrowers = true;

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.DeleteBorrower(borrower, tokenResponse.accessToken)
                .then(res => {
                    this.blueprintData = res.data.data;
                    this.blueprintDataEdit = cloneDeep(this.blueprintData);
                    this.loanTypeDisplay = this.agencyTypes.find(type => type.value === this.blueprintData.loanFile.agency).display;

                    this.isLoadingBorrowers = false;
                    this.showNotification('Borrower deleted successfully');
                }).catch(error => {
                    this.isLoadingBorrowers = false;
                    this.errorTitle = "Failed to Delete Borrower";

                    if (error.data) {
                      this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }
                    this.onRequestError(this.errorTitle, this.errorMsg);
                });            
            },
            confirmDeleteIncome() {

            },
            async getBlueprintData() {
                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();
                // let loanNumber = "555666";
                // let loanId = "b9168f0c-e071-47e3-ba9b-c9cc24f2d514";
                apiService.GetBlueprintInfo(this.loanNumber, this.loanId, tokenResponse.accessToken)
                .then(res => {
                    console.log(res.data.data);
                    this.blueprintData = res.data.data;
                    this.blueprintDataEdit = cloneDeep(this.blueprintData);
                    this.loanTypeDisplay = this.agencyTypes.find(type => type.value === this.blueprintData.loanFile.agency).display;

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                    this.errorTitle = "Failed to Load Blueprint File";

                    if (error.data) {
                      this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }
                    this.onRequestError(this.errorTitle, this.errorMsg);
                }); 
            },
            onAddBorrower() {
                this.addBorrowerMode = true;

                this.editBorrowerDialogTitle = 'Add borrower';
                this.toggleEditBorrowerDialog();
            },
            onAddBorrowerIncome(borrowerId) {
                let selectedBorrower = this.blueprintDataEdit.borrowers.find(b => b.borrower.borrowerId === borrowerId);

                if (selectedBorrower) {
                    this.selectedBorrower = cloneDeep(selectedBorrower);
                }

                this.addBorrowerIncomeMode = true;

                this.editBorrowerDialogTitle = 'Add borrower income source';

                this.filteredIncomeTypes = this.incomeTypes.slice();
                this.filteredOtherIncomeTypes = this.otherIncomeTypes.slice();

                this.toggleEditBorrowerDialog();               
            },
            onBlueprintTabSelected(evt) {
                this.selectedBlueprintTab = evt.selected;
            },
            onCloseNotification(flag) {
                this[flag] = false;
            },
            onDeleteBorrower(borrowerId) {
                let selectedBorrower = this.blueprintDataEdit.borrowers.find(b => b.borrower.borrowerId === borrowerId);

                if (selectedBorrower) {
                    this.selectedBorrower = cloneDeep(selectedBorrower);

                    this.deleteBorrower = true;
                    this.toggleConfirmDialog();
                }
            },
            onDeleteBorrowerIncome(borrowerId, income) {
                let selectedBorrower = this.blueprintDataEdit.borrowers.find(b => b.borrower.borrowerId === borrowerId);

                if (selectedBorrower) {
                    this.selectedBorrower = cloneDeep(selectedBorrower);

                    let borrowerIncome = this.selectedBorrower.incomeSummary.find(i => i.id === income.id);

                    if (borrowerIncome) {
                        this.selectedBorrowerIncome = cloneDeep(borrowerIncome);
                    }

                    this.deleteBorrowerIncome = true;
                    this.toggleConfirmDialog();
                }
            },
            onEditBorrowerInfo(borrowerId) {
                let selectedBorrower = this.blueprintDataEdit.borrowers.find(b => b.borrower.borrowerId === borrowerId);

                if (selectedBorrower) {
                    this.selectedBorrower = cloneDeep(selectedBorrower);
                }

                this.editBorrowerInfoMode = true;

                this.editBorrowerDialogTitle = 'Edit borrower information';
                this.toggleEditBorrowerDialog();
            },
            onEditBorrowerIncome(borrowerId, income) {
                let selectedBorrower = this.blueprintDataEdit.borrowers.find(b => b.borrower.borrowerId === borrowerId);

                if (selectedBorrower) {
                    this.selectedBorrower = cloneDeep(selectedBorrower);

                    let borrowerIncome = this.selectedBorrower.incomeSummary.find(i => i.id === income.id);

                    if (borrowerIncome) {
                        this.selectedBorrowerIncome = cloneDeep(borrowerIncome);
                    }

                    this.editBorrowerIncomeMode = true;

                    this.editBorrowerDialogTitle = 'Edit borrower income';
                    this.toggleEditBorrowerDialog();
                }
            },
            onIncomeTypeFilterChange(evt) {
                this.filteredIncomeTypes = filterBy(this.incomeTypes, evt.filter);
            },
            onIncomeTypeSelected(evt) {
                if (this.otherIncomeTypes.some(type => type === evt.value)) {
                    this.newIncomeType.type = 'OTHER';
                    this.newIncomeType.name = evt.value;
                } else {
                    this.newIncomeType.type = evt.value;
                }

                //this.updateBorrowerInfoBtnDisabled = false;
            },
            onLoanTypeChange(evt) {
                this.blueprintDataEdit.loanFile.agency = evt.value;

                this.checkForChanges();
            },
            onOtherIncomeTypeFilterChange(evt) {
                this.filteredOtherIncomeTypes = filterBy(this.otherIncomeTypes, evt.filter);
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;
                this.isAttachmentLoading = false;
                this.errorAlert = true;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.showErrorDialog = true;
            },
            onYearsAnalyzedChange(evt) {
                this.blueprintDataEdit.loanFile.want2yrAnalysis = Boolean(evt.value);

                this.checkForChanges();
            },
            showNotification(notificationMsg) {
                this.notificationMsg = notificationMsg;
                this.successNotification = true;

                setTimeout(() => {
                    this.successNotification = false;
                    this.notificationMsg = '';
                }, 4000);
            },
            toggleConfirmDialog() {
                this.showConfirmDialog = !this.showConfirmDialog;

                if (!this.showConfirmDialog) {
                    this.selectedBorrower = {};
                    this.selectedBorrowerIncome = {};

                    this.deleteBorrower = false;
                    this.deleteBorrowerIncome = false;
                }
            },
            toggleEditBorrowerDialog() {
                this.showBorrowerEditDialog = !this.showBorrowerEditDialog;

                if (!this.showBorrowerEditDialog) {
                    this.editBorrowerDialogTitle = '';
                    this.addBorrowerIncomeMode = false;
                    this.editBorrowerInfoMode = false;
                    this.editBorrowerIncomeMode = false;
                    this.addBorrowerMode = false;

                    this.selectedBorrower = {};
                    this.selectedBorrowerIncome = {};

                    this.newIncomeType = {
                        type: '',
                        name: ''
                    }
         
                    this.newBorrower = {
                        first: '',
                        last: '',
                        ssn: ''
                    }

                    this.updateBorrowerInfoBtnDisabled = true;
                    this.showIncomeTypes = true;
                }
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if(!this.showErrorDialog) {
                this.errorAlert = false;
                this.errorMsg = '';
                }
            },
            async updateBorrower() {
                let borrower = {
                    First: this.selectedBorrower.borrower.first,
                    Last: this.selectedBorrower.borrower.last,
                    SSN: this.selectedBorrower.borrower.ssn,
                    FileFileId: this.blueprintData.loanFile.fileId,
                    BorrowerId: this.selectedBorrower.borrower.borrowerId
                };

                this.toggleEditBorrowerDialog();

                this.isLoadingBorrowers = true;

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.UpdateBorrower(borrower, tokenResponse.accessToken)
                .then(res => {
                    this.blueprintData = res.data.data;
                    this.blueprintDataEdit = cloneDeep(this.blueprintData);
                    this.loanTypeDisplay = this.agencyTypes.find(type => type.value === this.blueprintData.loanFile.agency).display;

                    this.isLoadingBorrowers = false;
                    this.showNotification('Borrower updated successfully');
                }).catch(error => {
                    this.isLoadingBorrowers = false;
                    this.errorTitle = "Failed to Update Borrower";

                    if (error.data) {
                      this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }
                    this.onRequestError(this.errorTitle, this.errorMsg);
                }); 
            },
            updateBorrowerInfo() {
                if (this.addBorrowerMode) {
                    return this.addBorrower();
                }

                if (this.editBorrowerInfoMode) {
                    return this.updateBorrower();
                }
            },
            async updateFile() {
                this.isLoadingFile = true;

                let file = {
                    FileId: this.blueprintDataEdit.loanFile.fileId,
                    Agency: this.blueprintDataEdit.loanFile.agency,
                    loanNumber: this.blueprintDataEdit.loanFile.loanNumber,
                    AnlysisY1: this.blueprintDataEdit.loanFile.analysisY1,
                    want2yrAnalysis: this.blueprintDataEdit.loanFile.want2yrAnalysis,
                    IsLockedForUW: this.blueprintDataEdit.loanFile.isLockedForUW,
                    AdjustSelectedIncome: this.blueprintDataEdit.loanFile.adjustSelectedIncome
                };

                let tokenResponse = await auth.acquireTokenResponse();

                apiService.UpdateFile(file, tokenResponse.accessToken)
                .then(res => {
                    this.blueprintData.loanFile = res.data.data;
                    this.blueprintDataEdit = cloneDeep(this.blueprintData);
                    this.loanTypeDisplay = this.agencyTypes.find(type => type.value === this.blueprintData.loanFile.agency).display;

                    this.isLoadingFile = false;
                    this.showNotification('File updated successfully');

                    this.checkForChanges();
                }).catch(error => {
                    this.isLoadingFile = false;
                    this.errorTitle = "Failed to Update Borrower";

                    if (error.data) {
                      this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }
                    this.onRequestError(this.errorTitle, this.errorMsg);
                });
            },
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'k-button': Button,
            'loader': Loader,
            'k-notification': Notification,
            'k-notification-group': NotificationGroup,
            'k-fade': Fade,
            'k-tabstrip': TabStrip,
            'k-radio': RadioButton,
            'k-dropdown': DropDownList,
            'k-checkbox': Checkbox,
            'k-grid': Grid,
            'k-input': Input,
            'k-switch': Switch
        }   
    }
</script>

<style>
    @import '/src/assets/css/blueprintDialog.css';
</style>
